import './step-slider.scss';
import 'slick-carousel';

export default () => {
	let $jsStepsSlider = $( '.js-steps-slider' );

	$jsStepsSlider.slick( {
		rows: 0,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		swipeToSlide: true,
		arrows: true,
		appendArrows: $( '.slide-arrows' ),
		dots: false,
		prevArrow: '<a href="#" class="prev-arrow"><i class="icon-arrow-left"></i><a>',
		nextArrow: '<a href="#" class="next-arrow"><i class="icon-arrow-right"></i></</a>',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	} );
};
